import RoundedContainer from "./nav-rounded-container"
import { usePlayState } from "play/hooks/use-play-state"

export default function Timer(props: { visible: boolean }) {
  const { visible } = props
  const { timer } = usePlayState()

  return (
    <RoundedContainer visible={visible}>
      {timer.secondsRemaining}
    </RoundedContainer>
  )
}
